import { getAdminAuthHeaders } from './adminApi';

const API_BASE_URL = process.env.REACT_APP_GOTTEA_API_BASE_URL || 'https://gottea-search-5gtrn.ondigitalocean.app';

async function getAuthHeaders() {
  return getAdminAuthHeaders();
}

async function parseResponse(response) {
  const body = await response.json().catch(() => ({}));
  if (!response.ok || body.success === false) {
    throw new Error(body.error || body.message || `Request failed with status ${response.status}`);
  }
  return body.data || body;
}

async function request(path, options = {}) {
  const authHeaders = await getAuthHeaders();
  const response = await fetch(`${API_BASE_URL}${path}`, {
    ...options,
    headers: {
      ...authHeaders,
      'Content-Type': 'application/json',
      ...(options.headers || {}),
    },
  });
  return parseResponse(response);
}

export async function searchAppUsers(payload) {
  return request('/users/admin/search', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchAppUserActivity(userId, options = {}) {
  const params = new URLSearchParams();
  ['ledgerLimit', 'ordersLimit', 'ledgerCursor', 'ordersCursor'].forEach((key) => {
    if (options[key]) params.set(key, options[key]);
  });
  const suffix = params.toString() ? `?${params.toString()}` : '';
  return request(`/users/admin/${encodeURIComponent(userId)}/activity${suffix}`);
}

export async function createCrmUserExport(payload) {
  return request('/users/admin/exports', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchCrmUserExports() {
  return request('/users/admin/exports');
}

export async function fetchCrmUserExport(exportId) {
  return request(`/users/admin/exports/${exportId}`);
}

export async function createCrmUserExportDownloadUrl(exportId) {
  return request(`/users/admin/exports/${exportId}/download`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export async function fetchAppUserAgeGroups(payload) {
  return request('/users/admin/age-groups', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchAppUserCharts(payload) {
  return request('/users/admin/charts', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchCrmCampaignSegments() {
  return request('/users/admin/campaign-segments');
}

export async function previewCrmCampaignAudience(payload) {
  return request('/users/admin/campaigns/preview', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function fetchCrmCampaigns() {
  return request('/users/admin/campaigns');
}

export async function fetchCrmCampaign(campaignId) {
  return request(`/users/admin/campaigns/${campaignId}`);
}

export async function createCrmCampaign(payload) {
  return request('/users/admin/campaigns', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function testSendCrmCampaign(campaignId, userId) {
  return request(`/users/admin/campaigns/${campaignId}/test-send`, {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
}

export async function sendCrmCampaign(campaignId) {
  return request(`/users/admin/campaigns/${campaignId}/send`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export async function deleteCrmCampaign(campaignId) {
  return request(`/users/admin/campaigns/${campaignId}`, {
    method: 'DELETE',
  });
}

export async function refreshCrmCampaignReport(campaignId) {
  return request(`/users/admin/campaigns/${campaignId}/report/refresh`, {
    method: 'POST',
    body: JSON.stringify({}),
  });
}

export async function previewManualOrderAward(payload) {
  return request('/loyalty/admin/order-awards/preview', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function awardManualOrder(payload) {
  return request('/loyalty/admin/order-awards', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function awardManualTokens(payload) {
  return request('/loyalty/admin/token-awards', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}

export async function awardManualReward(payload) {
  return request('/loyalty/admin/reward-awards', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
}
